// Global authentication event handler
import { authManager } from './auth-manager';
import router from '@/router';
import axios from 'axios';

const siteBackend = process.env.VUE_APP_API_SITE_BACKEND;

class GlobalAuth {
	async handleSessionExpired(reason = 'Session expired') {
		try {
			authManager.clearTokens();
			sessionStorage.removeItem('currentUser');
			
			if (window.authCache) {
				window.authCache.isAuthenticated = false;
				window.authCache.timestamp = 0;
			}
			
			try {
				await axios.post(`${siteBackend}/api/admin/logout`, {}, {
					withCredentials: true,
					timeout: 3000
				});
			} catch (logoutError) {
				console.debug('Logout call failed (expected):', logoutError.message);
			}
			
			this.showSessionExpiredNotification(reason);
			
			if (router.currentRoute.value.path !== '/login') {
				router.push('/login');
			}
		} catch (error) {
			router.push('/login');
		}
	}
	
	showSessionExpiredNotification(reason) {
		const toast = document.createElement('div');
		toast.className = 'fixed top-4 right-4 z-50 bg-red-500/90 backdrop-blur-md text-white px-6 py-4 rounded-lg shadow-lg border border-red-500/50 max-w-sm';
		toast.style.animation = 'slideInRight 0.3s ease-out';
		
		toast.innerHTML = `
			<div class="flex items-center gap-3">
				<svg class="w-5 h-5 text-red-200 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
				</svg>
				<div>
					<p class="font-bold text-sm">Session Expired</p>
					<p class="text-xs text-red-200">Please log in again to continue</p>
				</div>
				<button onclick="this.parentElement.parentElement.remove()" class="ml-2 text-red-200 hover:text-white">
					<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
					</svg>
				</button>
			</div>
		`;
		
		if (!document.getElementById('auth-toast-styles')) {
			const style = document.createElement('style');
			style.id = 'auth-toast-styles';
			style.textContent = `
				@keyframes slideInRight {
					from { transform: translateX(100%); opacity: 0; }
					to { transform: translateX(0); opacity: 1; }
				}
			`;
			document.head.appendChild(style);
		}
		
		document.body.appendChild(toast);
		
		setTimeout(() => {
			if (toast.parentElement) {
				toast.style.animation = 'slideInRight 0.3s ease-in reverse';
				setTimeout(() => toast.remove(), 300);
			}
		}, 5000);
	}
}

export const globalAuth = new GlobalAuth();
export default globalAuth;